"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../../utils");
const imxes_1 = require("../../config/contracts/imxes");
const offchainPoolToken_1 = __importDefault(require("../offchainPoolToken"));
class OffchainBorrowable extends offchainPoolToken_1.default {
    // Simulates `accrueInterest` from `BInterestRateModel.sol`
    _accrueInterest() {
        return __awaiter(this, void 0, void 0, function* () {
            const [totalBalance, borrows, index, accrualTimestamp, borrowRate] = yield Promise.all([
                this.getPoolTokenParamFloat("totalBalance"),
                this.getPoolTokenParamFloat("totalBorrows"),
                this.getPoolTokenParamFloat("borrowIndex"),
                this.getPoolTokenParamFloat("accrualTimestamp"),
                this.getPoolTokenParamFloat("borrowRate"),
            ]);
            const timeElapsed = Date.now() / 1000 - accrualTimestamp;
            if (timeElapsed === 0)
                return {
                    totalBalance,
                    totalBorrows: borrows,
                    borrowIndex: index,
                    timeElapsed,
                    interest: 0,
                };
            const interestFactor = borrowRate * timeElapsed;
            const interest = interestFactor * borrows;
            const totalBorrows = borrows + interest;
            const borrowIndex = index + interestFactor * index;
            return { totalBalance, totalBorrows, borrowIndex, timeElapsed, interest };
        });
    }
    // Simulates `_calculateBorrowRate` from `BInterestRateModel.sol`, uses `accruedInterestIndices`
    // to simulate interest accrual first since this function is always called after `accrueInterest`.
    _calculateBorrowRate() {
        return __awaiter(this, void 0, void 0, function* () {
            let borrowRate = 0;
            const KINK_MULTIPLIER = this.lendingPool.getKinkMultiplier();
            const KINK_BORROW_RATE_MAX = 792.7448 / 1e9; // 2500% per year 
            const KINK_BORROW_RATE_MIN = 0.31709792 / 1e9; // 1% per year
            const [_kinkUtilizationRate, _adjustSpeed, _borrowRate, _kinkBorrowRate, _rateUpdateTimestamp,] = yield Promise.all([
                this.getPoolTokenParamFloat("kinkUtilizationRate"),
                this.getPoolTokenParamFloat("adjustSpeed"),
                this.getPoolTokenParamFloat("borrowRate"),
                this.getPoolTokenParamFloat("kinkBorrowRate"),
                // This should be same most of time, cant get it from subgraph since no event
                this.getPoolTokenParamFloat("accrualTimestamp"),
            ]);
            // Calculate new kink borrow rate
            const timeElapsed = Date.now() / 1000 - _rateUpdateTimestamp;
            let kinkBorrowRate = 0;
            if (timeElapsed > 0) {
                let adjustFactor = 0;
                if (_borrowRate < _kinkBorrowRate) {
                    const tmp = (_kinkBorrowRate - _borrowRate) / _kinkBorrowRate * _adjustSpeed * timeElapsed;
                    adjustFactor = tmp > 1 ? 0 : 1 - tmp;
                }
                else {
                    const tmp = (_borrowRate - _kinkBorrowRate) / _kinkBorrowRate * _adjustSpeed * timeElapsed;
                    adjustFactor = 1 + tmp;
                }
                kinkBorrowRate = _kinkBorrowRate * adjustFactor;
                if (kinkBorrowRate > KINK_BORROW_RATE_MAX)
                    kinkBorrowRate = KINK_BORROW_RATE_MAX;
                if (kinkBorrowRate < KINK_BORROW_RATE_MIN)
                    kinkBorrowRate = KINK_BORROW_RATE_MIN;
            }
            // Simulate accrual
            const { totalBalance, totalBorrows } = yield this._accrueInterest();
            ;
            const _actualBalance = totalBalance + totalBorrows;
            const _utilizationRate = _actualBalance === 0 ? 0 : totalBorrows / _actualBalance;
            if (_utilizationRate <= _kinkUtilizationRate) {
                borrowRate = kinkBorrowRate * _utilizationRate / _kinkUtilizationRate;
            }
            else {
                const overUtil = (_utilizationRate - _kinkUtilizationRate) / (1 - _kinkUtilizationRate);
                borrowRate = ((KINK_MULTIPLIER - 1) * overUtil + 1) * kinkBorrowRate;
            }
            return { borrowRate, kinkBorrowRate };
        });
    }
    constructor(lendingPool, poolTokenType) {
        super();
        this.getOffchain = () => this.lendingPool.getOffchain();
        this.getLendingPool = () => this.lendingPool;
        this.getPoolTokenType = () => this.poolTokenType;
        this.lendingPool = lendingPool;
        this.poolTokenType = poolTokenType;
    }
    getPoolTokenData() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolData = yield this.lendingPool.getLendingPoolData();
            return lendingPoolData[this.poolTokenType];
        });
    }
    // Reserve Factor
    getReserveFactor() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getPoolTokenParamFloat("reserveFactor");
        });
    }
    // Kink Borrow Rate
    getKinkBorrowRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const { kinkBorrowRate } = yield this._calculateBorrowRate();
            return kinkBorrowRate;
        });
    }
    // Kink Utilization Rate
    getKinkUtilizationRate() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getPoolTokenParamFloat("kinkUtilizationRate");
        });
    }
    // Adjust speed
    getAdjustSpeed() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getPoolTokenParamFloat("adjustSpeed");
        });
    }
    // Borrow tracker
    getBorrowTracker() {
        return __awaiter(this, void 0, void 0, function* () {
            const borrowTracker = yield this.getPoolTokenParam("borrowTracker");
            return borrowTracker !== null && borrowTracker !== void 0 ? borrowTracker : "0x0000000000000000000000000000000000000000";
        });
    }
    // Borrow Index
    getBorrowIndex() {
        return __awaiter(this, void 0, void 0, function* () {
            const { borrowIndex } = yield this._accrueInterest();
            return borrowIndex;
        });
    }
    // Accrue Timestamp
    getAccrualTimestamp() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getPoolTokenParamFloat("accrualTimestamp");
        });
    }
    // Total borrows
    getTotalBorrows() {
        return __awaiter(this, void 0, void 0, function* () {
            const { totalBorrows } = yield this._accrueInterest();
            return totalBorrows;
        });
    }
    getTotalBorrowsUSD() {
        return __awaiter(this, void 0, void 0, function* () {
            const totalBorrows = yield this.getTotalBorrows();
            const tokenPrice = yield this.getTokenPriceFast();
            return totalBorrows * tokenPrice;
        });
    }
    // Borrow rate
    getBorrowRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const { borrowRate } = yield this._calculateBorrowRate();
            return borrowRate;
        });
    }
    getBorrowAPR() {
        return __awaiter(this, void 0, void 0, function* () {
            const borrowRate = yield this.getBorrowRate();
            return (0, utils_1.toAPR)(borrowRate);
        });
    }
    getNextBorrowRate(borrowAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const { totalBalance, totalBorrows } = yield this._accrueInterest();
            const supply = totalBalance + totalBorrows;
            const UR = (borrowAmount + totalBorrows) / supply;
            const { kinkBorrowRate: kinkBR } = yield this._calculateBorrowRate();
            const kinkUR = yield this.getKinkUtilizationRate();
            if (UR < kinkUR)
                return UR / kinkUR * kinkBR;
            const kinkMultiplier = this.lendingPool.getKinkMultiplier();
            return ((UR - kinkUR) / (1 - kinkUR) * (kinkMultiplier - 1) + 1) * kinkBR;
        });
    }
    getNextBorrowAPR(borrowAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const borrowRate = yield this.getNextBorrowRate(borrowAmount);
            return (0, utils_1.toAPR)(borrowRate);
        });
    }
    // Supply
    getSupply() {
        return __awaiter(this, void 0, void 0, function* () {
            const { totalBalance, totalBorrows } = yield this._accrueInterest();
            return totalBalance + totalBorrows;
        });
    }
    getSupplyUSD() {
        return __awaiter(this, void 0, void 0, function* () {
            const supply = yield this.getSupply();
            const tokenPrice = yield this.getTokenPriceFast();
            return supply * tokenPrice;
        });
    }
    // Utilization Rate
    getUtilizationRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const { totalBalance, totalBorrows } = yield this._accrueInterest();
            if (totalBorrows == 0)
                return 0;
            return totalBorrows / (totalBalance + totalBorrows);
        });
    }
    // Supply Rate
    getSupplyRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const borrowRate = yield this.getBorrowRate();
            const utilizationRate = yield this.getUtilizationRate();
            const reserveFactor = yield this.getReserveFactor();
            return borrowRate * utilizationRate * (1 - reserveFactor);
        });
    }
    getSupplyAPR() {
        return __awaiter(this, void 0, void 0, function* () {
            const supplyRate = yield this.getSupplyRate();
            return (0, utils_1.toAPR)(supplyRate);
        });
    }
    getNextSupplyRate(supplyAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const { totalBalance, totalBorrows } = yield this._accrueInterest();
            const supply = totalBalance + totalBorrows;
            const UR = totalBorrows / (supply + supplyAmount);
            const { kinkBorrowRate: kinkBR } = yield this._calculateBorrowRate();
            const kinkUR = yield this.getKinkUtilizationRate();
            const reserveFactor = yield this.getReserveFactor();
            if (UR < kinkUR)
                return UR / kinkUR * kinkBR * UR * (1 - reserveFactor);
            const kinkMultiplier = this.lendingPool.getKinkMultiplier();
            return ((UR - kinkUR) / (1 - kinkUR) * (kinkMultiplier - 1) + 1) * kinkBR * UR * (1 - reserveFactor);
        });
    }
    getNextSupplyAPR(supplyAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const supplyRate = yield this.getNextSupplyRate(supplyAmount);
            return (0, utils_1.toAPR)(supplyRate);
        });
    }
    // Reward Speed
    getFarmingRewardsRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const poolTokenData = yield this.getPoolTokenData();
            const rewards = poolTokenData.rewards;
            if (rewards && rewards.length > 0)
                return rewards;
            const FINISH_DELAY = 3600 * 24;
            const farmingPoolData = poolTokenData.farmingPool;
            if (farmingPoolData === null)
                return [];
            const segmentLength = parseInt(farmingPoolData.segmentLength);
            const epochAmount = parseFloat(farmingPoolData.epochAmount);
            const epochBegin = parseInt(farmingPoolData.epochBegin);
            const epochEnd = epochBegin + segmentLength;
            const timestamp = (new Date()).getTime() / 1000;
            if (timestamp - FINISH_DELAY > epochEnd) {
                // How to manage better this case? Maybe check shares on distributor
                return [];
            }
            return [{
                    rewardToken: imxes_1.IMX[this.getOffchain().network],
                    rewardRate: epochAmount / segmentLength
                }];
        });
    }
    // Farming
    getFarmingRewards() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getNextFarmingRewards(0);
        });
    }
    getNextFarmingRewards(borrowAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const farmingRewards = yield this.getFarmingRewardsRate();
            const currentBorrowedUSD = yield this.getTotalBorrowsUSD();
            const tokenPrice = yield this.getTokenPriceFast();
            const additionalBorrowsUSD = borrowAmount * tokenPrice;
            const totalBorrowedUSD = currentBorrowedUSD + additionalBorrowsUSD;
            if (totalBorrowedUSD === 0)
                return [];
            const rewards = [];
            for (const reward of farmingRewards) {
                const rewardPrice = yield this.getOffchain().getPriceHelper().getDebankTokenPrice(reward.rewardToken);
                rewards.push({
                    APR: (0, utils_1.toAPR)((rewardPrice * reward.rewardRate) / totalBorrowedUSD),
                    symbol: reward.rewardToken == "0x98878b06940ae243284ca214f92bb71a2b032b8a" ? "WMOVR" :
                        reward.rewardToken == "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270" ? "WMATIC" :
                            reward.rewardToken == "0x6659a9c5cd313974343e30b4fdffd95bd4b4dcd2" ? "IMX" :
                                reward.rewardToken == "0x7b35ce522cb72e4077baeb96cb923a5529764a00" ? "IMX" :
                                    reward.rewardToken == "0x60bb3d364b765c497c8ce50ae0ae3f0882c5bd05" ? "IMX" :
                                        reward.rewardToken == "0x9c67ee39e3c4954396b9142010653f17257dd39c" ? "IMX" :
                                            reward.rewardToken == "0xea6887e4a9cda1b77e70129e5fba830cdb5cddef" ? "IMX" :
                                                reward.rewardToken == "0x900f1Ec5819FA087d368877cD03B265Bf1802667" ? "IMX" :
                                                    reward.rewardToken == "0xea38f1ccf77bf43f352636241b05dd8f6f5f52b2" ? "IMX" :
                                                        "IBEX",
                });
            }
            return rewards;
        });
    }
    getFarmingAPR() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getNextFarmingAPR(0);
        });
    }
    getNextFarmingAPR(borrowAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const rewards = yield this.getNextFarmingRewards(borrowAmount);
            let APR = 0;
            for (const reward of rewards) {
                APR += reward.APR;
            }
            return APR;
        });
    }
    // Past Data
    getPoolTokenDataPast24h() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolDataPast = yield this.lendingPool.getLendingPoolDataPast24h();
            if (!lendingPoolDataPast)
                return undefined;
            return lendingPoolDataPast[this.poolTokenType];
        });
    }
    getPoolTokenDataPast7d() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolDataPast = yield this.lendingPool.getLendingPoolDataPast7d();
            if (!lendingPoolDataPast)
                return undefined;
            return lendingPoolDataPast[this.poolTokenType];
        });
    }
    // Average Borrow APR
    getAverageBorrowAPR(poolTokenDataPast, fallback) {
        return __awaiter(this, void 0, void 0, function* () {
            if (poolTokenDataPast) {
                const accrualTimestampPast = parseFloat(poolTokenDataPast.accrualTimestamp);
                const borrowIndexPast = parseFloat(poolTokenDataPast.borrowIndex);
                const accrualTimestampNow = yield this.getAccrualTimestamp();
                const borrowIndexNow = yield this.getBorrowIndex();
                if (accrualTimestampNow > accrualTimestampPast) {
                    const borrowRate = (borrowIndexNow / borrowIndexPast - 1) / (accrualTimestampNow - accrualTimestampPast);
                    return borrowRate * 3600 * 24 * 365;
                }
            }
            return fallback;
        });
    }
    getAverage24hBorrowAPR() {
        return __awaiter(this, void 0, void 0, function* () {
            const poolTokenDataPast = yield this.getPoolTokenDataPast24h();
            return this.getAverageBorrowAPR(poolTokenDataPast, this.getBorrowAPR());
        });
    }
    getAverage7dBorrowAPR() {
        return __awaiter(this, void 0, void 0, function* () {
            const poolTokenDataPast = yield this.getPoolTokenDataPast7d();
            return this.getAverageBorrowAPR(poolTokenDataPast, this.getAverage24hBorrowAPR());
        });
    }
    // Average Supply APR
    getAverageSupplyAPR(poolTokenDataPast, fallback) {
        return __awaiter(this, void 0, void 0, function* () {
            if (poolTokenDataPast) {
                const accrualTimestampPast = parseFloat(poolTokenDataPast.accrualTimestamp);
                const exchangeRatePast = parseFloat(poolTokenDataPast.exchangeRate);
                const accrualTimestampNow = yield this.getAccrualTimestamp();
                const exchangeRateNow = yield this.getExchangeRate();
                if (accrualTimestampNow > accrualTimestampPast) {
                    const supplyRate = (exchangeRateNow / exchangeRatePast - 1) / (accrualTimestampNow - accrualTimestampPast);
                    return supplyRate * 3600 * 24 * 365;
                }
            }
            return fallback;
        });
    }
    getAverage24hSupplyAPR() {
        return __awaiter(this, void 0, void 0, function* () {
            const poolTokenDataPast = yield this.getPoolTokenDataPast24h();
            return this.getAverageSupplyAPR(poolTokenDataPast, this.getSupplyAPR());
        });
    }
    getAverage7dSupplyAPR() {
        return __awaiter(this, void 0, void 0, function* () {
            const poolTokenDataPast = yield this.getPoolTokenDataPast7d();
            return this.getAverageSupplyAPR(poolTokenDataPast, this.getAverage24hSupplyAPR());
        });
    }
    // Token price getters
    getTokenPriceFast(fallback = true) {
        const _super = Object.create(null, {
            getTokenPriceFast: { get: () => super.getTokenPriceFast }
        });
        return __awaiter(this, void 0, void 0, function* () {
            let tokenAddress = yield this.getUnderlyingAddress();
            let tokenPrices = yield this.getOffchain().getPriceHelper().getSubgraphTokensPrice();
            let tokenPrice = tokenPrices[tokenAddress];
            if (tokenPrice !== undefined && tokenPrice > 0)
                return tokenPrice;
            return _super.getTokenPriceFast.call(this, fallback);
        });
    }
    getTokenPriceAccurate() {
        return __awaiter(this, void 0, void 0, function* () {
            let tokenAddress = yield this.getUnderlyingAddress();
            return this.getOffchain().getPriceHelper().getDebankTokenPrice(tokenAddress);
        });
    }
}
exports.default = OffchainBorrowable;
